import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';

// an interface for sending data to to be displayed in DialogComponent.
export interface BeachyDialogData {
  error: Error | null;
  message: string | null;
  title: string | null;
}

// NOTE: see https://material.angular.io/components/dialog/api for config.
@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    NgClass,
    MatDialogModule,
    MatButtonModule
]
})
export class DialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  data = inject<BeachyDialogData>(MAT_DIALOG_DATA);

  hasError: boolean = false;

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.hasError = !!this.data.error;
  }
}
